"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionActions = _interopRequireDefault(require("@material-ui/core/AccordionActions"));

var _AccordionDetails = _interopRequireDefault(require("@material-ui/core/AccordionDetails"));

var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = _interopRequireDefault(require("./styles"));

var _excluded = ["id", "defaultExpanded", "disabled", "expanded", "expandDetails", "expandIcon", "expandSummary", "onChange", "className", "startIcon", "removeMarginExpanded", "unmountOnExit", "summaryProps", "detailsProps", "expandActions"];

var ExpansionPanel = function ExpansionPanel(props) {
  var id = props.id,
      defaultExpanded = props.defaultExpanded,
      disabled = props.disabled,
      expanded = props.expanded,
      expandDetails = props.expandDetails,
      expandIcon = props.expandIcon,
      expandSummary = props.expandSummary,
      onChange = props.onChange,
      className = props.className,
      startIcon = props.startIcon,
      removeMarginExpanded = props.removeMarginExpanded,
      unmountOnExit = props.unmountOnExit,
      summaryProps = props.summaryProps,
      detailsProps = props.detailsProps,
      expandActions = props.expandActions,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);

  var renderActions = function renderActions() {
    if (expandActions && (0, _typeof2.default)(expandActions) === "object" && "props" in expandActions) {
      var _expandActions$props = expandActions.props,
          useChildrenOnly = _expandActions$props.useChildrenOnly,
          children = _expandActions$props.children;

      if (useChildrenOnly) {
        // eslint-disable-next-line no-console
        console.warn("useChildrenOnly is deprecated. You should instead pass in a React Fragment");
      }

      return /*#__PURE__*/_react.default.createElement(_AccordionActions.default, {
        className: "prmbl-expansionPanel-actions"
      }, useChildrenOnly ? children : expandActions);
    } else {
      return /*#__PURE__*/_react.default.createElement(_AccordionActions.default, {
        className: "prmbl-expansionPanel-actions"
      }, expandActions);
    }
  };

  var classes = (0, _styles.default)(props);
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, (0, _extends2.default)({
    id: id,
    className: (0, _classnames.default)("prmbl-expansionPanel", className, classes.root),
    defaultExpanded: defaultExpanded,
    disabled: disabled,
    expanded: expanded,
    onChange: onChange,
    TransitionProps: {
      unmountOnExit: unmountOnExit
    }
  }, otherProps, {
    classes: {
      expanded: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.removeMarginExpanded, removeMarginExpanded), classes.expanded),
      rounded: classes.rounded,
      disabled: classes.disabled
    }
  }), /*#__PURE__*/_react.default.createElement(_AccordionSummary.default, (0, _extends2.default)({
    expandIcon: expandIcon
  }, summaryProps, {
    className: (0, _classnames.default)("prmbl-expansionPanel-summary", summaryProps === null || summaryProps === void 0 ? void 0 : summaryProps.className)
  }), startIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.startIcon
  }, startIcon), expandSummary), /*#__PURE__*/_react.default.createElement(_AccordionDetails.default, (0, _extends2.default)({}, detailsProps, {
    className: (0, _classnames.default)("prmbl-expansionPanel-details", detailsProps === null || detailsProps === void 0 ? void 0 : detailsProps.className)
  }), expandDetails), renderActions());
};

ExpansionPanel.defaultProps = {
  expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null),
  unmountOnExit: false,
  removeMarginExpanded: false,
  disabled: false,
  defaultExpanded: false
};
var _default = ExpansionPanel;
exports.default = _default;